import React, { useEffect, useState } from "react";
import CustomTable from "@components/CustomTable";
import myStore from "./store";
import { Observer } from "mobx-react";
import {
  fetchDynamicFilters,
  transformData,
} from "@helpers/helpers";
import { useTranslation } from "react-i18next";
import { ExceptionsRecordColumns } from "./ExceptionsRecordColumns";
import { ExceptionsRecordFilters } from "./ExceptionsRecordFilters";
import { ExceptionsRecordActions, ExceptionsRecordGlobalActions } from "./ExceptionsRecordActions";
import {
  PINNING_INITIAL_STATE,
  FILTER_DISPLAY_VALUES,
  SELECTED_FILTERS_DISPLAY,
} from "./ExceptionsRecordComponent.constants";

const ExceptionsRecordComponent = () => {
  const { t: translate, i18n } = useTranslation();

  const [dynamicFilters, setDynamicFilters] = useState([]);
  useEffect(() => {
    fetchDynamicFilters("ExceptionFilters", (newFilters) => {
      setDynamicFilters(newFilters);
    });
  }, []);

  const getDynamicFilters = (key, onlyChildren = false) => {
    return transformData(
      (!!dynamicFilters &&
        !!dynamicFilters.length &&
        dynamicFilters.find((filter) => filter.ColumnName === key)?.Values) ||
        [],
      onlyChildren
    );
  };

  const externalDisplays = [
    ...getDynamicFilters("ReconciliationStreamTag"),
    ...getDynamicFilters("AgingTierTag"),
  ];

  // Generate column definitions
  const columns = ExceptionsRecordColumns({ translate });

  // Generate filter definitions
  const filterDefinitions = ExceptionsRecordFilters({
    translate,
    getDynamicFilters,
  });

  // Generate action definitions
  const actions = ExceptionsRecordActions({ translate, store: myStore });

  // Generate global action definitions
  const GlobalActions = ExceptionsRecordGlobalActions({
    translate,
    store: myStore,
  });

  // Get filter display values
  const filterDisplayValues = FILTER_DISPLAY_VALUES(translate);

  // Get filters array (filterDefinitions is already wrapped in array)
  const filters = filterDefinitions;

  // Get selected filters display labels
  const selectedFiltersDisplay = SELECTED_FILTERS_DISPLAY(translate);

  return (
    <Observer>
      {() => {
        return (
          <CustomTable
            pinnedRowHeight={57}
            headerHeight={37}
            store={myStore}
            columnsWithoutPin={columns}
            loading={myStore.loading}
            pinCondition={(row) => {
              return row.IsScheduled;
            }}
            filterDisplayValues={filterDisplayValues}
            selectedFiltersDisplay={selectedFiltersDisplay}
            filters={filters}
            pinningInitialState={PINNING_INITIAL_STATE}
            setParentSelectedValues={() => {}}
            actions={actions}
            prefix="ExceptionsRecord"
            title={translate("exceptions-record.title")}
            selectableCondition={(row) => {
              return true;
            }}
            GlobalActions={GlobalActions}
            showExportButton={true}
            activityTag="ExportExceptionRecords"
            language={i18n.language}
            maxTableHeight={"calc(100dvh - 350px)"}
            externalDisplays={externalDisplays}
          />
        );
      }}
    </Observer>
  );
};

export default ExceptionsRecordComponent;
